"use strict"

import {observable, action} from "mobx"

class WarningDialogStore {
	@observable isOpen = false
	@observable message = ""

	@action open(message) {
		this.message = message
		this.isOpen = true
	}

	@action close() {
		this.isOpen = false
		this.message = ""
	}
}

var singleton = new WarningDialogStore()
export default singleton

